import { NavLink } from 'react-router-dom';

export default function getItemData(itemData) {
  return {
    activeClassName: 'mdc-deprecated-list-item--selected',
    component: NavLink,
    exact: true,
    ...itemData,
  };
}
